
function Youtube(){

    this.build();
    this.playerLeft = null;
    this.playerRight = null;
    this.playerFull = null;
}

Youtube.prototype.build = function(){

    this.youtubeVideo = document.querySelectorAll('.youtube');
    // this.youtube_video_right = document.querySelectorAll('.youtube-right');
    // this.youtube_video_full = document.querySelectorAll('.youtube-full');

    if( this.youtubeVideo ){
        this.loadScript();
    }

};

Youtube.prototype.loadScript = function(){

    let that = this;
    let tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = function () {

        that.youtubeVideo.forEach( (video) => {
            let movie = video.querySelector('[data-youtube]');
            let player = new YT.Player(movie, {
                height: '100%',
                width: '100%',
                videoId: movie.dataset.youtube,
                playerVars: {rel: 0, showinfo: 0, ecver: 2}
            });

            let cover = video.querySelector('.youtube-cover');
            cover.addEventListener('click', (e) => {
                player.playVideo();
                cover.classList.add('is-playing');
            });
        });

    };
};
